export const MODAL_OPTIONS_REQUIRE_CONFIRM = {
    backdrop: 'static',
    keyboard: false,
    focus: true
} as const;
